
import Login from '../pages/authentication/login'
import Register from '../pages/authentication/register'
import ResetPassword from '../pages/authentication/reset-password'
import ForgetPassword from '../pages/authentication/forgot-password'
import Logout from '../pages/account/logout'
import Home from '../pages/home/'
import Products from '../pages/products/products'
import Product from '../pages/products/product-single'
import Wishlist from '../pages/account/account-wishlist'
import Profile  from '../pages/account/account-profile'
import Review from '../pages/account/account-review'
import Address from '../pages/account/account-address'
import Orders from '../pages/account/account-orders'
import Cart from '../pages/cart/cart'
import PaymentMethod from '../pages/account/account-payment-method'
import Occasion from '../pages/account/account-occasion'
import Checkout from '../pages/checkout/checkout'
import ViewOccasions from '../pages/account/view-occasions'
import ViewInvitedOccasions from '../pages/account/view-invited-occasions'
import ViewOrderDetails from '../pages/account/view-order-details'
import PrivacyPolicy from '../pages/privacy-policy/privacy-policy'
import RefundPolicy from '../pages/refund-policy/refund-policy'
import TermsnConditions from '../pages/terms-and-conditions/terms-and-conditions'
import TermsOfUse from '../pages/terms-of-use/terms-of-use'
import ViewOrderShipment from '../pages/account/view-order-shipment'
import ViewTrackShipment from '../pages/account/view-track-shipment'
import ViewReturns from '../pages/account/view-returns'
import ReturnDetails from '../pages/account/account-view-return-details'
import TrackReturn from '../pages/account/account-track-return'
import RemoveOrderItems from '../pages/account/account-remove-order-items'
import ReturnItemPolicy from '../pages/return-item-policy/return-item-policy'
import Categories from '../pages/categories'
import Dashboard from '../pages/account/account-dashboard'
import CurrentOrders from '../pages/account/account-current-orders'
import TrackOrder from '../pages/account/account-track-order'
import OrderHistory from '../pages/account/account-order-history'
import Favorites from '../pages/account/account-favorites'
import NotificationPage from '../pages/account/account-notifications'
import CustomerSupportPage from '../pages/support/support-ticket'
import NotificationHistory from '../pages/notification/notification-history'
import MenuPage from '../pages/menu/menuPage'
import ContactUs from '../pages/contact/contact'
import AboutUsPage from '../pages/aboutUs/aboutUsPage'
import MonthlySpecial from '../pages/special'
import FaqsPage from '../pages/faqs/FaqsPage'
import Blogs from '../pages/blogs'
import { BlogDetailsPage } from '../pages/blogs/blogDetails'
import StoreItemPage from '../pages/store'
import AllVendorsPage from '../pages/vendors'


const baseRoutes = [
    { path: "/login", element: Login },
    { path: "/register", element: Register },
    { path: "/reset-password/:token/:guid", element: ResetPassword },
    { path: "/forgot-password", element: ForgetPassword },
]
const protectedRoutes = [
    { path: "/", element: Dashboard },
    { path: "/account/wishlist", element: Wishlist },
    { path: "/account/profile", element: Profile },
    { path: "/account/dashboard", element: Dashboard },
    { path: "/account/review", element: Review },
    { path: "/account/addresses", element: Address },
    { path: "/account/notifications", element:  NotificationPage},
    { path: "/notifications-history", element:  NotificationHistory},
    { path: "/support", element:  CustomerSupportPage},
    { path: "/account/orders", element: Orders },
    { path: "/account/current-orders", element: CurrentOrders },
    { path: "/account/order-history", element: OrderHistory },
    { path: "/account/order-track/:id", element: TrackOrder },
    { path: "/account/favorites", element: Favorites },
    { path: "/account/orders/:id", element: ViewOrderDetails },
    { path: "/account/orders/shipments/:id", element: ViewOrderShipment },
    { path: "/account/orders/shipments/track-shipment/:orderID/:id", element: ViewTrackShipment },
    { path: "/account/returns", element: ViewReturns },
    { path: "/account/returns/return-details/:id", element: ReturnDetails },
    { path: "/account/returns/track-return/:id", element: TrackReturn },
    { path: "/account/orders/remove-order-items/:id", element: RemoveOrderItems },
    { path: "/account/payment-methods", element: PaymentMethod },
    { path: "/account/occasions", element: Occasion },
    { path: "/account/occasions/:id", element: ViewOccasions },
    { path: "/account/occasions/invite/:id", element: ViewInvitedOccasions },
    { path: "/logout", element: Logout },
]
const publicRoutes = [
	{ path: "/", element: Home, header: true, footer: true },
    { path: "/categories", element: Categories, header: true, footer: true },
    // { path: "/products", element: Products, header: true, footer: true },
    // { path: "/product/:id", element: Product, header: true, footer: true },
    { path: "/cart", element: Cart, header: true, footer: true },
    { path: "/checkout", element: Checkout, header: true, footer: true },
    { path: "/privacy-policy", element: PrivacyPolicy, header: true, footer: true },
    { path: "/return-policy", element: RefundPolicy, header: true, footer: true },
    { path: "/return-item-policy", element: ReturnItemPolicy, header: true, footer: true },
    { path: "/terms-of-use", element: TermsOfUse, header: true, footer: true },
    // { path: "/privacy-policy", element: PrivacyPolicy, header: false, footer: false },
    { path: "/return-policy/app", element: RefundPolicy, header: false, footer: false },
    { path: "/return-item-policy/app", element: ReturnItemPolicy, header: false, footer: false },
    { path: "/terms-of-use/app", element: TermsOfUse, header: false, footer: false },
    { path: "/menu", element: MenuPage, header: true, footer:true },
    { path: "/store", element: StoreItemPage, header: true, footer:true },
    { path: "/store/vendors", element: AllVendorsPage, header: true, footer: true },
    { path: "/terms-and-conditions", element: TermsnConditions, header: true, footer:true },
    { path: "/contact", element: ContactUs, header: true, footer:true },
    { path: "/about-us", element: AboutUsPage, header: true, footer: true },
    { path: "/special", element: MonthlySpecial , header: true, footer: true },
    { path: "/faqs", element: FaqsPage , header: true, footer: true },
    { path: "/blogs", element: Blogs , header: true, footer: true },
    { path: "/blog/:id", element: BlogDetailsPage , header: true, footer: true },
]


export { protectedRoutes, publicRoutes, baseRoutes };